var map = {
	"./template.betprofessor": 1621,
	"./template.betprofessor.tsx": 1621,
	"./template.betroyale": 1622,
	"./template.betroyale.tsx": 1622,
	"./template.default": 669,
	"./template.default.tsx": 669,
	"./template.juicybet": 1623,
	"./template.juicybet.tsx": 1623,
	"./template.puntcity": 1624,
	"./template.puntcity.tsx": 1624,
	"./template.questbet": 1625,
	"./template.questbet.tsx": 1625,
	"./template.ts": 497,
	"./template.vikingbet": 1626,
	"./template.vikingbet.tsx": 1626,
	"./template.wellbet": 1627,
	"./template.wellbet.tsx": 1627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2465;